import { defineAsyncComponent } from 'vue'
export default {
  base: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/base.vue").then(m => m.default || m)),
  second: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/second.vue").then(m => m.default || m))
}